/**
 * The Inventory Sync feedback survey, linked from both the legacy settings page and the refreshed one.
 */
export const INVENTORY_SYNC_FEEDBACK_FORM_URL = 'https://form.jotform.com/241495724938166';
